import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { Dommage } from './dommage.class';

export class TdgSupport {
	@Required
	@Primary
	id: number;

	@Required
	label: string;

	prefix: string;
	preposition: string;

	isActive: boolean;
	expertise: boolean;

	dommages: Dommage[];
}
